var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#00A743",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8C22 8 25 15 25 15C25 15 22 22 15 22C8 22 5 15 5 15C5 15 8 8 15 8ZM15 11.9375C13.067 11.9375 11.5 13.3086 11.5 15C11.5 16.6914 13.067 18.0625 15 18.0625C16.933 18.0625 18.5 16.6914 18.5 15C18.5 13.3086 16.933 11.9375 15 11.9375ZM15 16.3125C14.1729 16.3125 13.5 15.7237 13.5 15C13.5 14.2763 14.1729 13.6875 15 13.6875C15.8271 13.6875 16.5 14.2763 16.5 15C16.5 15.7237 15.8271 16.3125 15 16.3125Z",
    fill: "#00A743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b6f048afa493ea66c25eb723dd3f47ea.svg";
export { ForwardRef as ReactComponent };